import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {ServiceRequest} from '../../../dealer-system/Models/ServiceRequest';
import {Helper} from '../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../dealer-system/Services/order.service';
import {Order} from '../../../back-office/Models/Order';
import {AuthenticationService} from '../../Services/authentication.service';
import {environment} from '../../../../environments/environment';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {OrderItemProductFabricCollection} from '../../../back-office/Models/OrderItemProductFabricCollection';
import {ServiceRequestService} from '../../../dealer-system/Services/service-request.service';
import {ServiceSubject} from '../../../back-office/Models/ServiceSubject';
import {Product} from '../../../back-office/Models/Product';
import {Option} from '../../../back-office/Models/Option';
import {carpetOptionName, carpetRoleLabelKey, carpetRowsOfElement, carpetSizeLabel} from '../../../helpers/carpet-price';

@Component({
  selector: 'app-manage-service-request',
  templateUrl: './manage-service-request.component.html',
  styleUrls: ['./manage-service-request.component.scss']
})

export class ManageServiceRequestComponent implements OnInit {
  public step = 1;
  public serviceRequest: ServiceRequest = new ServiceRequest();
  public order: Order = new Order();
  public orderId: number;
  public baseURL = environment.absolutePath;
  public baseUrl = environment.apiUrl;
  public addFileItem = false;
  public isUploading = false;
  public isSubmitting = false;
  public isNotAdd = false;
  public imageUrl = null;
  public hasBaseDropZoneOver = false;
  public disableBtn = false;
  public ordersTypeahead = new EventEmitter<string>();
  public selectedOrders = [];
  public orderIsSelected = false;
  public orderArticles = [];
  public selectedArticle;
  public orderItem: any;
  public selectedElement = [];
  public serviceSubjectList: Array<ServiceSubject> = [];
  public serviceSubjectQueue = [];
  public serviceSubjectItemActive = undefined;
  public formIsValidate = false;
  public elementSelection = false;
  @ViewChild('sendRequestModal', {static: false}) sendRequestModal = null;
  @ViewChild('serviceRequestForm', {static: false}) serviceRequestForm = null;

  constructor(
    public helper: Helper,
    private router: Router,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private auth: AuthenticationService,
    private serviceRequestService: ServiceRequestService
  ) {
  }

  ngOnInit() {
    this.serviceRequestService.getServiceSubjects().subscribe(resp => {
      this.serviceSubjectList = resp;
    });
    this.route.params.subscribe(params => {

      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        this.orderService.getOrder(this.orderId).subscribe((resp) => {
          this.order = resp;
          if (this.order) {
            this.selectedOrders = [
              {label: this.order.orderNo + ' (' + this.order.reference + ')', value: this.order.id}
            ];

            this.orderIsSelected = true;

            this.loadOrderArticles();
          }
        });
      }
      this.searchOrderNumbers();
    });
  }

  submitItem(next: boolean) {
    if (next) {
      this.disableBtn = true;
      const serviceRequest = JSON.parse(JSON.stringify(this.serviceRequest));

      this.orderService.manageServiceRequest(serviceRequest, this.orderId).subscribe((resp) => {
        this.disableBtn = false;
        this.sendRequestModal.show();
      });
    } else {
      this.router.navigateByUrl('/dealer-system/order/overview');
    }
  }


  searchOrderNumbers() {
    this.ordersTypeahead.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      switchMap(term => this.orderService.getOrderNumbers('query=' + term))
    ).subscribe(res => {
      const options = [];
      res.forEach((item) => {
        options.push({label: item.orderNumber + ' (' + item.reference + ')', value: item.id});
      });
      this.selectedOrders = options;
    }, (err) => {
      this.selectedOrders = [];
    });

  }

  changeOrder(event) {
    this.orderId = event.value;
    this.orderService.getOrder(this.orderId).subscribe((resp) => {
      this.order = resp;
      this.loadOrderArticles();
      this.selectedArticle = null;
      this.orderItem = null;
    });
  }

  changeArticle(event) {
    this.selectedArticle = event.value;
    this.orderItem = this.order.orderItems.find(function (item) {
      return item.id == event.value;
    });
    this.wholeArticle(true);
  }

  loadOrderArticles() {
    const options = [];
    this.order.orderItems.forEach(function (item, index) {
      options.push({label: 'Article ' + (index + 1), value: item.id});
    });
    this.orderArticles = options;
  }

  orderItemCount(index) {
    return parseInt(index) + 1;
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null);
  }

  /** Carpet roles, exposed for the template so it doesn't hardcode magic strings */
  public readonly CARPET_ROLE_SHAPE = Option.CARPET_ROLE_SHAPE;
  public readonly CARPET_ROLE_FINISHING = Option.CARPET_ROLE_FINISHING;
  public readonly CARPET_ROLE_COLOUR = Option.CARPET_ROLE_COLOUR;

  /** A rug has no fabric — same check the order screen uses (D9) */
  isRugProduct(productItem): boolean {
    return Product.isRug(productItem?.product);
  }

  /**
   * D9: on this route the payload is the order itself, where the selected options hang
   * off the ARTICLE rather than the element — so the caller passes `orderItem`, the
   * same object the rest of this template already reads.
   */
  /**
   * The shape/finishing/colour of ONE element.
   *
   * This screen loads the order through the order endpoint, which does not serialize an
   * element's own option rows — only the ids (`orderItemOptionIds`). So the element's rows
   * are picked out of the article's list by those ids. Passing the article straight through
   * returned the FIRST matching row for every element, so a two-element rug reported
   * element one's shape twice.
   */
  rugOptionName(orderItem, productItem, carpetRole: string): string {
    return carpetOptionName(
      carpetRowsOfElement(orderItem?.orderItemOptions, productItem?.orderItemOptionIds),
      carpetRole
    );
  }

  carpetSizeLabel = carpetSizeLabel;
  carpetRoleLabelKey = carpetRoleLabelKey;

  changeElement(event, id) {
    if (event.target.checked) {
      const found = this.selectedElement.some((element) => element == id);
      if (!found) {
        this.selectedElement.push(id);
      }
    } else {
      this.selectedElement = this.selectedElement.filter((element) => element != id);
    }
  }

  prev() {
    if (this.step === 2 && this.serviceSubjectQueue.length > 0) {
      return this.serviceSubjectItemActive = this.serviceSubjectQueue.pop();
    }
    return this.step--;
  }

  next() {
    if (this.step === 2) {
      if (this.serviceSubjectQueue.length === 0) {
        this.serviceSubjectQueue.push(this.serviceSubjectItemActive);
        this.serviceSubjectItemActive = undefined;
        return;
      }
      const current = this.serviceSubjectQueue[this.serviceSubjectQueue.length - 1];
      const hasChildRows =
        current.serviceSubjectItems && current.serviceSubjectItems.length !== 0;
      const visibleChildren = this.getVisibleServiceSubjectItems();
      if (hasChildRows && visibleChildren.length > 0) {
        this.serviceSubjectQueue.push(this.serviceSubjectItemActive);
        this.serviceSubjectItemActive = undefined;
        return;
      }
    }
    this.step++;
  }

  openConfirmation() {
    if (!this.formIsValidate) {
      return;
    }
    this.isSubmitting = false;
    this.sendRequestModal.show();
  }

  storeServiceRequest() {
    if (!this.formIsValidate || this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.serviceRequest.serviceSubject = this.serviceSubjectQueue[0].id;
    this.serviceRequest.serviceSubjectItems = [];
    this.serviceSubjectQueue.forEach((item, index) => {
      if (index !== 0) {
        this.serviceRequest.serviceSubjectItems.push(item.id);
      }
    });

    this.serviceRequest.order = this.orderId;
    const files = [];
    this.serviceRequest.files.forEach((item) => {
      if (item.id) {
        files.push(item.id);
      } else {
        files.push(item);
      }
    });
    this.serviceRequest.files = files;
    this.serviceRequestService.newServiceRequest(this.serviceRequest).subscribe((res) => {
      this.sendRequestModal.hide();
      this.router.navigateByUrl(this.auth.isBackOffice() ? '/back-office/service/request/overview' : '/dealer-system/service/overview');
    }, () => {
      this.isSubmitting = false;
    });
  }

  formValidateCheck() {
    this.formIsValidate = !(!this.serviceRequest.message || !this.serviceSubjectQueue[0] || this.serviceRequest.order === null);
  }

  public wholeArticle(event) {
    if (event) {
      this.elementSelection = false;
      this.selectedElement = [];
      this.orderItem.orderItemProducts.forEach(element => {
        this.selectedElement.push(element.id);
      });
    } else {
      this.elementSelection = true;
      this.selectedElement = [];
    }
  }

  public setServiceSubject(serviceSubject) {
    return {...serviceSubject, isServiceSubject: true};
  }

  getVisibleServiceSubjectItems(): any[] {
    if (!this.serviceSubjectQueue.length) {
      return [];
    }
    const current = this.serviceSubjectQueue[this.serviceSubjectQueue.length - 1];
    const items = current.serviceSubjectItems || [];
    return items.filter(
      (item) =>
        !item.parentId ||
        (!current.isServiceSubject && item.parentId === current.id)
    );
  }

  getFontAwesomeIconFromMIME(mimeType) {
    const icon_classes = {
      // Media
      image: 'fa-file-image-o',
      audio: 'fa-file-audio-o',
      video: 'fa-file-video-o',
      // Documents
      'application/pdf': 'fa-file-pdf-o',
      'application/msword': 'fa-file-word-o',
      'application/vnd.ms-word': 'fa-file-word-o',
      'application/vnd.oasis.opendocument.text': 'fa-file-word-o',
      'application/vnd.openxmlformats-officedocument.wordprocessingml':
        'fa-file-word-o',
      'application/vnd.ms-excel': 'fa-file-excel-o',
      'application/vnd.openxmlformats-officedocument.spreadsheetml':
        'fa-file-excel-o',
      'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel-o',
      'application/vnd.ms-powerpoint': 'fa-file-powerpoint-o',
      'application/vnd.openxmlformats-officedocument.presentationml':
        'fa-file-powerpoint-o',
      'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint-o',
      'text/plain': 'fa-file-text-o',
      'text/html': 'fa-file-code-o',
      'application/json': 'fa-file-code-o',
      // Archives
      'application/gzip': 'fa-file-archive-o',
      'application/zip': 'fa-file-archive-o'
    };

    for (const key in icon_classes) {
      if (icon_classes.hasOwnProperty(key)) {
        if (mimeType.search(key) === 0) {
          return icon_classes[key];
        }
      } else {
        return 'fa-file-o';
      }
    }
  }
}
